import SectionHeading from './SectionHeading';
import LeadFormEmbed from '../LeadFormEmbed';
import Reveal from './Reveal';

export default function NewsletterSection() {
  return (
    <section className="section-padding bg-primary-light">
      <div className="section-container">
        <Reveal variant="up">
          <SectionHeading title="JOIN OUR NEWSLETTER" subtitle="Stay informed with the latest property investment opportunities and insights." />
          <div className="max-w-2xl mx-auto">
            <LeadFormEmbed formType="newsletter_form" minHeight={560} />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
